import React, { createContext, useState, useEffect, useMemo, useContext } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import api from '../api';

export const AuthContext = createContext({
  currentUser: null,
  userRole: null,
  userName: null,
  loading: true,
});

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [userName, setUserName] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        try {
          const res = await api.get(`/users/byFirebaseUid/${user.uid}`);
          setUserRole(res.data.role || null);
          setUserName(res.data.name || null);
        } catch (err) {
          console.error('Failed to fetch role:', err);
          setUserRole(null);
          setUserName(null);
        }
      } else {
        setUserRole(null);
        setUserName(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const contextValue = useMemo(
    () => ({ currentUser, userRole, userName, loading }),
    [currentUser, userRole, userName, loading]
  );

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
}

// helper hook
export function useAuth() {
  return useContext(AuthContext);
}